import { jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { Badge } from "antd";
import { defaultOverflowCount, rootClass } from "./constant.js";
import "./index.css";
import { forwardRef } from "react";
const BadgeComponent = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsx(Badge, {
        ref: ref,
        ...props,
        overflowCount: props.overflowCount || defaultOverflowCount,
        className: classnames(rootClass, props.className)
    }));
BadgeComponent.displayName = 'Badge';
const badge = BadgeComponent;
export { badge as default };
